const SCOPE = 'CurrencyToggle';

export const CHANGE_CURRENCY = `${SCOPE}/CHANGE_CURRENCY`;
export const SET_CURRENCY_EXCHANGE_MAP = `${SCOPE}/SET_CURRENCY_EXCHANGE_MAP`;
